import request from "./request"

/**
 * Hand this browser over to another session -- into the viewed account when
 * "View As" starts, back to the admin when it stops
 * (../wicked-maths-laravel/docs/VIEW_AS_USER.md).
 *
 * It writes the same `account` blob that authReducer's signIn writes, because
 * the reload immediately after re-reads exactly that on boot. No redux dispatch
 * is involved on purpose: the store is about to be rebuilt from scratch, so
 * updating it first would be updating state we are throwing away, and it would
 * drag a `connect()` into a page that otherwise needs none.
 *
 * The reload is the point, not a convenience. Every screen currently mounted was
 * rendered from the previous identity's data -- an admin's user table, or a
 * child's lesson list -- and a soft route change would leave that on screen
 * under the new session. A full load guarantees nothing of the old identity
 * survives.
 *
 * `win` is injected so the navigation can be asserted on; jsdom's
 * window.location is not spy-able. UpdateAvailableBanner takes the same seam.
 */
export const applyViewAsSession = ({ token, user }, win = window, to = "/") => {
	localStorage.setItem("account", JSON.stringify({ token, user }))
	request.setAuthToken(token)
	win.location.assign(to)
}

export default applyViewAsSession
